/*
 * l51-variant-persist v3.1.0
 * ---------------------------------------------------------------------------
 * Corrige la pérdida de selección de talla en Broadcast 8.x (Android/Chrome).
 *
 * CAUSA RAÍZ
 * Broadcast reemplaza el <product-info> en cada cambio de variante mediante
 * HTMLUpdateUtility.viewTransition(). Ese método:
 *   - inserta el nodo nuevo ANTES del viejo,
 *   - oculta el viejo con display:none pero lo deja en el DOM,
 *   - le renombra los id y reescribe los atributos form= con un timestamp,
 *   - recién lo elimina con setTimeout(..., 500).
 * Durante esos 500 ms conviven dos árboles del selector de variantes. En
 * Android/Chrome el click sintético post-touch (~300 ms) más el fetch en
 * gama media hacen que el tap aterrice sistemáticamente dentro de esa
 * ventana: el radio tocado pertenece al árbol muerto, su atributo form=
 * apunta a un id inexistente y el change nunca llega al input[name="id"]
 * vivo. La talla "no toma" o se agrega la variante equivocada.
 *
 * ESTRATEGIA
 * Guardar la elección del usuario en un Map keyed por producto y re-aplicarla
 * después de cada swap del DOM (pub/sub nativo + MutationObserver + reintentos
 * calibrados dentro de la ventana de 500 ms).
 *
 * Portado desde lab51-forus-CAT (theme.liquid, generación 3 — la validada en
 * producción). Ver README.md del kit.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__l51BroadcastSizeRequiredInit) return;
  window.__l51BroadcastSizeRequiredInit = true;

  /* =========================================================================
   * CONFIGURACIÓN
   * Sobrescribible por tienda definiendo window.L51_VARIANT_PERSIST ANTES de
   * cargar este script. No editar el bloque de abajo: usar el override.
   * ========================================================================= */
  var CFG = Object.assign(
    {
      // Texto del aviso cuando se intenta agregar sin talla.
      msgText: 'Debes seleccionar una talla',

      // true  -> además del fix, exige elegir talla (bloquea ATC, sin preselección).
      // false -> SOLO el fix de persistencia; respeta la preselección nativa.
      requireSizeSelection: true,

      // Cuánto dura el aviso en pantalla (ms).
      msgTimeoutMs: 4000,

      // Ventana del viewTransition de Broadcast. No tocar salvo que el tema
      // haya sido modificado.
      swapWindowMs: 500,

      // Contenedores que delimitan un "producto" en la página.
      rootSelector:
        '.shopify-section, [data-section-id], quick-add-modal, .quick-add, .product-item, product-form',

      // Contextos aislados (no deben tocar la barra sticky global).
      isolatedSelector: '.quick-add, quick-add-modal, .product-item',

      // Wrapper de cada opción tipo botón/swatch en Broadcast.
      wrapperSelector: '.radio__button',

      // Debounce del botón ATC mientras el tema recalcula la variante.
      // Solo se aplica si el picker expone data-variant-id.
      atcLockMs: 300,

      // Loguea en consola cada vez que recupera una selección perdida.
      // No hace falta ponerlo en true: se activa solo agregando ?l51debug=1
      // a la URL. Eso permite depurar en el sitio en producción, desde el
      // dispositivo del cliente, sin desplegar nada.
      debug: false,

      // Emite el evento l51_variant_rescue a dataLayer. Permite medir en
      // producción si el bug ocurre y con qué frecuencia.
      dataLayer: false
    },
    window.L51_VARIANT_PERSIST || {}
  );

  // ?l51debug=1 enciende el log sin necesidad de tocar el theme. Pensado para
  // depurar en producción desde el dispositivo donde el bug sí se reproduce.
  try {
    if (/[?&]l51debug=1/.test(window.location.search)) CFG.debug = true;
  } catch (e) {
    /* sin acceso a location: se queda con el valor de la config */
  }

  var SIZE_INPUT = 'input[type="radio"][data-l51-size-option="true"]';
  var ADD_FORM = 'form[action*="/cart/add"]';
  var SUBMIT_SEL =
    '[type="submit"], button[name="add"], [data-add-to-cart]';

  // Reintentos dentro de la ventana de swap. Calibrados contra los 500 ms.
  var RETRY_AFTER_CLICK = [20, 180, 350];
  var RETRY_AFTER_SWAP = [120, 320];
  var RETRY_AFTER_CHANGE = [250, 600];

  var selectedSizeByScope = new Map();
  var selectedVariantByScope = new Map();

  /* ========================================================================
   * SCOPE
   * ======================================================================== */

  function getRoot(el) {
    if (!(el instanceof Element)) return document;

    return (
      el.closest('quick-add-modal') ||
      el.closest('.quick-add') ||
      el.closest('.product-item') ||
      el.closest('.shopify-section') ||
      el.closest('[data-section-id]') ||
      el.closest('product-form') ||
      document
    );
  }

  function isIsolated(root) {
    return !!(root && root.closest && root.closest(CFG.isolatedSelector));
  }

  // Clave estable por producto. Debe sobrevivir al reemplazo del DOM, por eso
  // se prefiere la URL del producto por sobre cualquier id generado.
  function getScopeKey(root) {
    if (!(root instanceof Element)) return 'document';

    var urlEl = root.querySelector('[data-product-url]');
    var linkEl = root.querySelector('a[href*="/products/"]');
    var handleEl = root.closest('[data-product-handle]');

    var productUrl =
      (urlEl && urlEl.getAttribute('data-product-url')) ||
      (linkEl && linkEl.getAttribute('href')) ||
      (handleEl && handleEl.dataset.productHandle) ||
      root.dataset.productHandle ||
      '';

    if (productUrl) return 'product:' + productUrl.split('?')[0];

    var form = root.querySelector(ADD_FORM);
    if (form && form.id) return 'form:' + form.id;

    var idInput = root.querySelector('[name="id"]');
    if (idInput && idInput.form && idInput.form.id) {
      return 'form:' + idInput.form.id;
    }

    return root.dataset.sectionId || root.id || root.className || 'default';
  }

  function getSizeInputs(root) {
    if (!(root instanceof Element)) return [];
    return Array.from(root.querySelectorAll(SIZE_INPUT));
  }

  // Consulta el Map primero: tras un swap el DOM puede no tener nada checked
  // aunque el usuario sí haya elegido.
  function hasSelectedSize(root) {
    if (selectedSizeByScope.has(getScopeKey(root))) return true;
    return getSizeInputs(root).some(function (i) {
      return i.checked;
    });
  }

  function getSelectedSizeInput(root) {
    var stored = selectedSizeByScope.get(getScopeKey(root));

    if (stored) {
      var match = getSizeInputs(root).find(function (i) {
        return String(i.value) === String(stored);
      });
      if (match) return match;
    }

    return (
      getSizeInputs(root).find(function (i) {
        return i.checked;
      }) || null
    );
  }

  /* ========================================================================
   * VARIANT ID
   * Presente en quick-add y upsell (data-variant-id). En el picker de la PDP
   * normalmente no existe: en ese caso se devuelve '' y el flujo cae en la
   * ruta por valor de opción, que es la que usa el tema nativo.
   * ======================================================================== */

  function getVariantIdFromSizeInput(input) {
    if (!(input instanceof HTMLInputElement)) return '';

    var wrapper = input.closest(CFG.wrapperSelector);
    var externalLabel = null;

    if (input.id) {
      try {
        externalLabel = document.querySelector(
          'label[for="' + CSS.escape(input.id) + '"][data-var-id], ' +
            'label[for="' + CSS.escape(input.id) + '"][data-variant-id]'
        );
      } catch (e) {
        externalLabel = null;
      }
    }

    var label =
      (wrapper &&
        wrapper.querySelector('label[data-var-id], label[data-variant-id]')) ||
      externalLabel;

    return String(
      input.dataset.variantId ||
        input.dataset.varId ||
        input.getAttribute('data-variant-id') ||
        input.getAttribute('data-var-id') ||
        (label && label.dataset.variantId) ||
        (label && label.dataset.varId) ||
        (label && label.getAttribute('data-variant-id')) ||
        (label && label.getAttribute('data-var-id')) ||
        ''
    ).trim();
  }

  function getFormsFromRoot(root) {
    var forms = [];
    var context =
      root instanceof Element ? root.closest('.shopify-section') || root : document;

    if (context instanceof HTMLFormElement && context.matches(ADD_FORM)) {
      forms.push(context);
    }

    context.querySelectorAll(ADD_FORM).forEach(function (f) {
      forms.push(f);
    });

    if (root instanceof Element && !isIsolated(root)) {
      document
        .querySelectorAll('.container-sticky ' + ADD_FORM)
        .forEach(function (f) {
          forms.push(f);
        });
    }

    return Array.from(new Set(forms));
  }

  // Escribe el id de variante en el form. Cubre el caso de inputs asociados
  // por atributo form= (que es como Broadcast los enlaza) además de los
  // anidados, porque el swap reescribe justamente ese atributo.
  function setVariantOnForm(form, variantId) {
    if (!(form instanceof HTMLFormElement) || !variantId) return;

    var idInputs = Array.from(form.querySelectorAll('[name="id"]'));

    if (!idInputs.length && form.id) {
      document
        .querySelectorAll('[name="id"][form="' + CSS.escape(form.id) + '"]')
        .forEach(function (i) {
          idInputs.push(i);
        });
    }

    idInputs.forEach(function (input) {
      input.value = String(variantId);
      input.setAttribute('value', String(variantId));
    });

    form.dataset.l51SelectedVariantId = String(variantId);
  }

  function setVariantOnRoot(root, variantId) {
    if (!variantId) return;
    getFormsFromRoot(root).forEach(function (f) {
      setVariantOnForm(f, variantId);
    });
  }

  function getExpectedVariantId(root) {
    var saved = selectedVariantByScope.get(getScopeKey(root));
    if (saved) return String(saved);
    return getVariantIdFromSizeInput(getSelectedSizeInput(root));
  }

  /* ========================================================================
   * ESTADO DE CARGA DEL BOTÓN ATC
   * ======================================================================== */

  function eachSubmit(root, fn) {
    var context = (root.closest && root.closest('.shopify-section')) || document;
    context.querySelectorAll(ADD_FORM).forEach(function (form) {
      form.querySelectorAll(SUBMIT_SEL).forEach(fn);
    });
  }

  function setTemporaryLoadingState(root) {
    eachSubmit(root, function (btn) {
      btn.classList.add('l51-is-loading');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.7';
    });
  }

  function removeTemporaryLoadingState(root) {
    eachSubmit(root, function (btn) {
      btn.classList.remove('l51-is-loading');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  }

  // Mantiene el botón bloqueado hasta que el form refleje la variante
  // esperada, con timeout de seguridad. Sin variantId conocido, se libera
  // tras un debounce corto.
  function waitForSync(root, expectedVariantId) {
    if (!expectedVariantId) {
      setTimeout(function () {
        removeTemporaryLoadingState(root);
      }, CFG.atcLockMs);
      return;
    }

    if (root.__l51SyncInterval) clearInterval(root.__l51SyncInterval);

    var attempts = 0;
    var maxAttempts = 40; // 40 x 50ms = 2s

    root.__l51SyncInterval = setInterval(function () {
      attempts++;
      setVariantOnRoot(root, expectedVariantId);

      var synced = getFormsFromRoot(root).some(function (form) {
        var input =
          form.querySelector('[name="id"]') ||
          (form.id
            ? document.querySelector(
                '[name="id"][form="' + CSS.escape(form.id) + '"]'
              )
            : null);

        return input && String(input.value) === String(expectedVariantId);
      });

      if (synced || attempts >= maxAttempts) {
        clearInterval(root.__l51SyncInterval);
        root.__l51SyncInterval = null;
        setVariantOnRoot(root, expectedVariantId);
        removeTemporaryLoadingState(root);
      }
    }, 50);
  }

  /* ========================================================================
   * ESTADO "SIN TALLA"  (solo si requireSizeSelection)
   * ======================================================================== */

  function collect(root, selector, stickySelector) {
    var out = [];
    if (root instanceof Element) {
      root.querySelectorAll(selector).forEach(function (el) {
        out.push(el);
      });
    }
    if (!isIsolated(root) && stickySelector) {
      document.querySelectorAll(stickySelector).forEach(function (el) {
        out.push(el);
      });
    }
    return Array.from(new Set(out));
  }

  function setNoSizeState(root, locked) {
    if (!CFG.requireSizeSelection) return;

    collect(
      root,
      '.container-no-size',
      '.container-sticky .container-no-size'
    ).forEach(function (blocker) {
      blocker.classList.toggle('no-visible', !locked);
      blocker.setAttribute('aria-hidden', locked ? 'false' : 'true');
    });

    var areas = [root];
    if (!isIsolated(root)) {
      document.querySelectorAll('.container-sticky').forEach(function (el) {
        areas.push(el);
      });
    }

    Array.from(new Set(areas)).forEach(function (area) {
      if (!(area instanceof Element)) return;

      area.querySelectorAll('[data-l51-atc-normal-text]').forEach(function (el) {
        el.hidden = locked;
      });
      area.querySelectorAll('[data-l51-atc-size-text]').forEach(function (el) {
        el.hidden = !locked;
      });
      area.querySelectorAll('[data-l51-atc-price]').forEach(function (el) {
        el.hidden = locked;
      });
    });
  }

  function showNoSizeMessage(blocker) {
    if (!CFG.requireSizeSelection) return;

    var root = getRoot(blocker);

    collect(
      root,
      '.product__submit__buttons',
      '.container-sticky .product__submit__buttons'
    ).forEach(function (holder) {
      var msg = holder.querySelector(':scope > .l51-no-size-message');

      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'l51-no-size-message';
        msg.setAttribute('role', 'alert');
        msg.textContent = CFG.msgText;
        holder.insertBefore(msg, holder.firstChild);
      }

      msg.classList.add('is-visible');
      clearTimeout(msg.__timer);

      msg.__timer = setTimeout(function () {
        msg.classList.remove('is-visible');
      }, CFG.msgTimeoutMs);
    });
  }

  function scrollToVariants(blocker) {
    var root = getRoot(blocker);

    var target =
      root.querySelector('[data-variant-buttons]') ||
      root.querySelector('variant-selects') ||
      root.querySelector('.product__selectors') ||
      document.querySelector('.product__content [data-variant-buttons]') ||
      document.querySelector('.product__content variant-selects') ||
      document.querySelector('.product__content .product__selectors');

    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ========================================================================
   * TELEMETRÍA
   * Cuenta cuántas veces el kit tuvo que recuperar una selección perdida por
   * el swap. En consola: window.__l51VariantRescues
   * Con CFG.debug = true, además loguea cada rescate.
   * Con CFG.dataLayer = true, emite a dataLayer para medirlo en producción
   * (útil cuando hay reportes de clientes sin repro interna).
   * ======================================================================== */

  window.__l51VariantRescues = 0;

  function reportRescue(root, value) {
    window.__l51VariantRescues++;

    if (CFG.debug) {
      console.warn(
        '[l51-variant-persist] selección recuperada #' +
          window.__l51VariantRescues,
        { scope: getScopeKey(root), value: value }
      );
    }

    if (CFG.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'l51_variant_rescue',
        l51_scope: getScopeKey(root),
        l51_value: String(value),
        l51_count: window.__l51VariantRescues
      });
    }
  }

  /* ========================================================================
   * SELECCIÓN
   * ======================================================================== */

  // Registra la intención en pointerdown, ANTES de que el tema pueda hacer
  // swap del DOM. Es lo que permite recuperar la elección después.
  function markUserIntent(input) {
    if (!(input instanceof HTMLInputElement)) return;

    var root = getRoot(input);
    var key = getScopeKey(root);
    var variantId = getVariantIdFromSizeInput(input);

    root.dataset.l51UserSelectedSize = 'true';
    selectedSizeByScope.set(key, String(input.value));

    if (variantId) {
      selectedVariantByScope.set(key, String(variantId));
      setVariantOnRoot(root, variantId);
    }
  }

  function clearInitialSize(root) {
    if (!CFG.requireSizeSelection) return;
    if (!(root instanceof Element)) return;
    if (root.dataset.l51SizeCleared === 'true') return;
    if (root.dataset.l51UserSelectedSize === 'true') return;
    if (selectedSizeByScope.has(getScopeKey(root))) return;

    var inputs = getSizeInputs(root);
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      input.checked = false;
      input.removeAttribute('checked');

      var wrapper = input.closest(CFG.wrapperSelector);
      if (wrapper) wrapper.classList.remove('is-selected', 'checked', 'active');
    });

    setNoSizeState(root, true);
    root.dataset.l51SizeCleared = 'true';
  }

  // Propaga el valor a los controles nativos de OTRAS opciones (color, etc.)
  // para que Broadcast dispare su propio optionValueSelectionChange.
  function syncNativeOption(context, selectedValue) {
    if (!context || !selectedValue) return;

    context
      .querySelectorAll(
        'input[type="radio"]:not([data-l51-size-option="true"]), select'
      )
      .forEach(function (field) {
        if (field.tagName === 'SELECT') {
          var has = Array.from(field.options).some(function (o) {
            return String(o.value) === String(selectedValue);
          });

          if (has && String(field.value) !== String(selectedValue)) {
            field.value = selectedValue;
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (field.type === 'radio') {
          if (String(field.value) === String(selectedValue) && !field.checked) {
            field.checked = true;
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
  }

  function markActiveSize(input) {
    if (!(input instanceof HTMLInputElement)) return;

    var root = getRoot(input);
    var key = getScopeKey(root);
    var previousValue = selectedSizeByScope.get(key);
    var expectedVariantId = getVariantIdFromSizeInput(input);
    var sectionContext = root.closest('.shopify-section') || document;

    root.dataset.l51UserSelectedSize = 'true';

    // El bloqueo del ATC solo tiene sentido si hay un id que esperar. Sin él,
    // waitForSync libera por debounce y el único efecto sería oscurecer el
    // botón sin motivo. Pasa en themes cuyo picker no emite data-variant-id.
    if (expectedVariantId) setTemporaryLoadingState(root);

    // Se barre toda la sección: tras el swap pueden coexistir el árbol viejo
    // (display:none) y el nuevo, y ambos deben quedar coherentes.
    sectionContext.querySelectorAll(SIZE_INPUT).forEach(function (radio) {
      var isSelected = String(radio.value) === String(input.value);

      radio.checked = isSelected;

      if (isSelected) radio.setAttribute('checked', 'checked');
      else radio.removeAttribute('checked');

      var wrapper = radio.closest(CFG.wrapperSelector);
      if (wrapper) {
        wrapper.classList.toggle('is-selected', isSelected);
        wrapper.classList.toggle('checked', isSelected);
        wrapper.classList.toggle('active', isSelected);
      }
    });

    selectedSizeByScope.set(key, String(input.value));

    if (expectedVariantId) {
      selectedVariantByScope.set(key, String(expectedVariantId));
      setVariantOnRoot(root, expectedVariantId);
    }

    setNoSizeState(root, false);

    if (previousValue !== input.value) {
      syncNativeOption(sectionContext, input.value);
    }

    if (expectedVariantId) {
      setVariantOnRoot(root, expectedVariantId);
      requestAnimationFrame(function () {
        setVariantOnRoot(root, expectedVariantId);
      });
    }

    waitForSync(root, expectedVariantId);
  }

  function reapplySelectedSize(root) {
    if (!(root instanceof Element)) return;

    var selectedValue = selectedSizeByScope.get(getScopeKey(root));
    if (!selectedValue) return;

    var input = getSizeInputs(root).find(function (el) {
      return String(el.value) === String(selectedValue);
    });

    if (!input) return;

    // Si el input existía y NO estaba checked, el swap se comió la selección:
    // el bug acaba de ocurrir y esta línea es la que lo repara. Es la única
    // señal fiable de que el kit está haciendo algo, y sirve para medir el
    // bug en producción cuando no hay repro local.
    if (!input.checked) reportRescue(root, selectedValue);

    markActiveSize(input);
    setNoSizeState(root, false);
  }

  function initRoot(root) {
    if (!(root instanceof Element)) return;

    var key = getScopeKey(root);

    if (
      selectedSizeByScope.has(key) ||
      root.dataset.l51UserSelectedSize === 'true'
    ) {
      root.dataset.l51UserSelectedSize = 'true';
      reapplySelectedSize(root);
      setNoSizeState(root, false);
      return;
    }

    clearInitialSize(root);
    reapplySelectedSize(root);
  }

  function init() {
    document.querySelectorAll(CFG.rootSelector).forEach(initRoot);
  }

  function retry(root, delays) {
    delays.forEach(function (ms) {
      setTimeout(function () {
        reapplySelectedSize(root);
        setNoSizeState(root, false);
      }, ms);
    });
  }

  /* ========================================================================
   * LISTENERS
   * ======================================================================== */

  // Overlay "sin talla": intercepta en captura antes que el tema.
  document.addEventListener(
    'click',
    function (e) {
      if (!CFG.requireSizeSelection) return;

      var blocker = e.target.closest('.container-no-size');
      if (!blocker) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      showNoSizeMessage(blocker);
      scrollToVariants(blocker);
    },
    true
  );

  // CLAVE: pointerdown ocurre ~300ms antes que el click en Android. Se
  // registra la intención mientras el DOM todavía es el original.
  document.addEventListener(
    'pointerdown',
    function (e) {
      var label = e.target.closest(CFG.wrapperSelector + ' label');
      if (!label) return;

      var wrapper = label.closest(CFG.wrapperSelector);
      if (!wrapper) return;

      var input = wrapper.querySelector(SIZE_INPUT);
      if (!input) return;

      markUserIntent(input);
    },
    true
  );

  // Última oportunidad de fijar la variante antes de que el form se envíe.
  document.addEventListener(
    'pointerdown',
    function (e) {
      var addButton = e.target.closest(
        ADD_FORM + ' [type="submit"], ' +
          ADD_FORM + ' button[name="add"], ' +
          ADD_FORM + ' [data-add-to-cart]'
      );
      if (!addButton) return;

      var form = addButton.closest(ADD_FORM);
      if (!form) return;

      var expected = getExpectedVariantId(getRoot(form));
      if (expected) setVariantOnForm(form, expected);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var label = e.target.closest(CFG.wrapperSelector + ' label');
      if (!label) return;

      var wrapper = label.closest(CFG.wrapperSelector);
      if (!wrapper) return;

      var input = wrapper.querySelector(SIZE_INPUT);
      if (!input) return;

      markUserIntent(input);

      setTimeout(function () {
        markActiveSize(input);
      }, RETRY_AFTER_CLICK[0]);

      setTimeout(function () {
        markActiveSize(input);
      }, RETRY_AFTER_CLICK[1]);

      setTimeout(function () {
        reapplySelectedSize(getRoot(input));
      }, RETRY_AFTER_CLICK[2]);
    },
    false
  );

  document.addEventListener('change', function (e) {
    var input = e.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.type !== 'radio' ||
      input.dataset.l51SizeOption !== 'true'
    ) {
      return;
    }

    markUserIntent(input);
    markActiveSize(input);
    retry(getRoot(input), RETRY_AFTER_CHANGE);
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(ADD_FORM)) return;

      var root = getRoot(form);
      if (!getSizeInputs(root).length) return;

      if (CFG.requireSizeSelection && !hasSelectedSize(root)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        setNoSizeState(root, true);

        var blocker =
          root.querySelector('.container-no-size') ||
          document.querySelector('.container-no-size');

        showNoSizeMessage(blocker || root);
        scrollToVariants(blocker || root);
        return false;
      }

      var expected = getExpectedVariantId(root);
      if (expected) setVariantOnForm(form, expected);
    },
    true
  );

  /* ========================================================================
   * RE-APLICACIÓN TRAS EL SWAP DEL DOM
   * ======================================================================== */

  // Señal determinista del propio tema. Más confiable que los timeouts;
  // estos quedan como red de seguridad.
  try {
    if (
      typeof subscribe === 'function' &&
      window.theme &&
      window.theme.PUB_SUB_EVENTS &&
      window.theme.PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () {
        requestAnimationFrame(init);
      });
    }
  } catch (err) {
    /* el tema no expone pub/sub: se sigue con observer + timeouts */
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          !node.matches(CFG.rootSelector) &&
          !node.querySelector(SIZE_INPUT)
        ) {
          return;
        }

        var root = getRoot(node);

        if (selectedSizeByScope.has(getScopeKey(root))) {
          root.dataset.l51UserSelectedSize = 'true';

          requestAnimationFrame(function () {
            reapplySelectedSize(root);
            setNoSizeState(root, false);
          });

          retry(root, RETRY_AFTER_SWAP);
        } else {
          initRoot(root);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:quick-add:open', init);
  window.addEventListener('load', init);

  if (document.readyState !== 'loading') init();
})();
